import { all, fork } from 'redux-saga/effects';
import { actionSaga } from './action';
import { requestSaga } from './request';
import { sceneSaga } from './scene';
import { nextSceneSaga } from './nextScene';
import { loadSaga } from './load';
import { eventsSaga } from './events';
import { timerSaga } from './timer';

export default function* moduleSaga() {
  yield all([
    fork(sceneSaga),
    fork(requestSaga),
    fork(actionSaga),
    fork(nextSceneSaga),
    fork(loadSaga),
    fork(eventsSaga),
    fork(timerSaga),
  ]);
}
